import React from "react";
import styled from "styled-components";
import { Flex, Box, Text, Heading } from "rebass";
import omit from "lodash.omit";

import Button from "../ui/Button";

type Props = {
  title: string,
  price: string,
  currency: string,
  period: string,
  subscriberCount: number,
  pricePerMessage: number,
  subscribeButtonClick: () => mixed,
  siteMetadata: {
    appUrl: string
  },
  subscribeButtonLabel?: string
};

const propsToOmit = [
  "title",
  "price",
  "currency",
  "period",
  "subscriberCount",
  "pricePerMessage",
  "subscribeButtonClick",
  "siteMetadata",
  "subscribeButtonLabel"
];

const PlanCard = (props: Props) => (
  <Flex wrap>
    <CardBox {...omit(props, propsToOmit)}>
      <Title p={[3]} f={[2, 2, 4]}>
        {props.title}
      </Title>

      <PriceDetails py={[3]}>
        <Price>
          ${props.price} <Currency>{props.currency}</Currency>
        </Price>
        <Period f={[1]}>{props.period}</Period>
      </PriceDetails>

      <FeatureList>
        <li>
          <Text f={[2]}>
            <strong>{props.subscriberCount} Qualified Leads</strong>*
          </Text>
        </li>
        <li>
          <Text f={[2]}>Conversion Funnel Tracking</Text>
        </li>
        <li>
          <Text f={[2]}>Live Chat Integration</Text>
        </li>
        <li>
          <Text f={[2]}>Analytics Dashboard</Text>
        </li>
        <li>
          <Text f={[2]}>Integration Tools</Text>
        </li>
      </FeatureList>

      <Footer py={["20px"]}>
        <SubscribeButton
          is="a"
          href={props.siteMetadata.appUrl}
          onClick={props.subscribeButtonClick}
        >
          {props.subscribeButtonLabel}
        </SubscribeButton>
      </Footer>
    </CardBox>

    <Box mt={[4]}>
      <Text f={[1]} color="gray3" align="center">
        <em>
          * Qualified Leads = Non-converted or disqualified lead + Any qualified
          leads in current month
        </em>
      </Text>
    </Box>
  </Flex>
);

export default PlanCard;

PlanCard.defaultProps = {
  subscribeButtonLabel: "Get Started"
};

// Styled Components
const FeatureList = styled.ul`
  background: #fff;
  margin: 0;
  padding: 30px 0;

  li {
    list-style: none;
    margin-bottom: 30px;
    text-align: center;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const CardBox = styled(Box)`
  border-radius: 10px;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.07);
  overflow: hidden;
`;

const Title = styled(Heading)`
  background: ${p => p.theme.colors.support2};
  color: #fff;
  font-weight: 300;
  text-align: center;
`;

const PriceDetails = styled(Box)`
  background: ${p => p.theme.colors.beige};
  border-bottom: 1px solid #eee;
  color: ${p => p.theme.colors.support2};
  text-align: center;
`;

const Price = styled(Text)`
  font-weight: 600;
  position: relative;
`;

const Currency = styled.span`
  bottom: 2px;
  color: #a9a9a9;
  font-size: 11px;
  font-weight: 300;
  padding-left: 4px;
  position: absolute;
`;

const Period = styled(Text)`
  font-weight: 300;
`;

const Footer = styled(Box)`
  background: #fff;
  border-top: 1px dashed #eee;
  text-align: center;
`;

const SubscribeButton = styled(Button)`
  background-color: ${p => p.theme.colors.facebookBlue};
  font-size: 16px;
  height: 46px;
  line-height: 46px;
`;



// WEBPACK FOOTER //
// ./src/components/Pricing/PlanCard.jsx